import { v4 as uuid } from "uuid";
import { DataField } from "@iventis/domain-model/model/dataField";
import { DataFieldType } from "@iventis/domain-model/model/dataFieldType";
import { ScheduleConfigVenueLocationType } from "@iventis/domain-model/model/scheduleConfigVenueLocationType";
import { EMPTY_GUID } from "@iventis/utilities";

export const createVenueLocationType = (dataFields: string[] = [], allowedParentTypeId?: string) =>
    ({
        id: uuid(),
        name: "",
        allowedParentType: allowedParentTypeId,
        dataFields,
        apiNameSingular: undefined,
        apiNamePlural: undefined,
    } as ScheduleConfigVenueLocationType);

export const createTwoVenueLocationTypes = (topLevelDataFields: DataField[]) => {
    const toppestLevelVenueLocationType = createVenueLocationType(
        topLevelDataFields.map((df) => df.id),
        undefined
    );
    const secondLevelVenueLocationType = createVenueLocationType([], toppestLevelVenueLocationType.id);
    return [toppestLevelVenueLocationType, secondLevelVenueLocationType];
};

export const appendClusterToVenueLocationTypes = (venueLocationTypes: ScheduleConfigVenueLocationType[]): ScheduleConfigVenueLocationType[] => {
    if (venueLocationTypes.length !== 2) {
        throw new Error("Can only append clusters to venue locations if two exist");
    }
    const topMost = venueLocationTypes.find((t) => t.allowedParentType === undefined || t.allowedParentType === EMPTY_GUID);
    const bottomMost = venueLocationTypes.find((t) => t.allowedParentType === topMost.id);
    const clusters = createVenueLocationType(undefined);
    const newSecondLevel = {
        ...topMost,
        allowedParentType: clusters.id,
    };
    topMost.allowedParentType = clusters.id;
    return [clusters, newSecondLevel, bottomMost];
};

export const createVenueCodeDatafield = () =>
    ({
        id: uuid(),
        name: "Venue code",
        customerIdentifierName: "Venue code",
        allowedMetadataProperties: [],
        type: DataFieldType.Text,
        listValues: [],
        hierarchyMetadataPropertyName: undefined,
        showInApi: false,
        projectId: undefined,
        apiNameSingular: undefined,
        apiNamePlural: undefined,
    } as DataField);
